const MAX_LENGTH = 160;
const MIN_LENGTH_BEFORE_WORD_BOUNDARY = 100;

export function metaDescription(...parts: (string | null | undefined)[]): string | undefined {
  const text = parts
    .filter((part) => part?.trim())
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  if (!text) return undefined;
  if (text.length <= MAX_LENGTH) return text;

  const truncated = text.slice(0, MAX_LENGTH - 1);
  const lastSpace = truncated.lastIndexOf(" ");
  const cut = lastSpace > MIN_LENGTH_BEFORE_WORD_BOUNDARY ? truncated.slice(0, lastSpace) : truncated;
  return `${cut.replace(/[\s,;:.]+$/, "")}…`;
}
